import React from "react";
import Card from "./Card";
import Chatbot from '../../assets/logos/Chatbot.svg';


const getStatusClass = (badge = "") => {
  switch (badge.trim()) {
    case "Damage Assessment":
      return "status-inactive";
    case "Pre-Construction":
      return "status-active";
    case "Environmental Review":
      return "status-update";
    case "Award":
      return "status-purple"
    case "Team Lead Review":
      return "status-danger";
    case "Construction":
      return "status-one";
    case "Eligibility Determination Review":
      return "status-two";
    case "DOB Reivew":
      return "status-three"
    case "Communication":
      return "status-danger"
    default:
      return "status-update";
  }
};



const ActivityFeedCard = ({ entries = [], onAskAgent }) => (
  <Card className="activity-card">
    <div className="feed">
      {entries.map((e, idx) => (
        <div className="feed-entry">
          <div className="feed-icon-wrapper">
            <div className="feed-icon">{e.icon || ""}</div>
            <div className="feed-line" />
          </div>

          <div className="feed-content">
            <div className="feed-meta">{e.meta}</div>

            <div className="feed-text-line">
              <span
                className="feed-text"
                dangerouslySetInnerHTML={{
                  __html: e.text, // Render formatted text
                }}
              />
              {e.badge && (
               <span className={`feed-badge ${getStatusClass(e.badge)}`}>{e.badge}</span>
              )}
            </div>

            {e.links?.length > 0 && (
              <div className="feed-links">
                {e.links.map((l, i) => (
                  <a
                    className="feed-link" href={l.href} onClick={(t) => {
                        t.preventDefault();
                        onAskAgent?.(e.case);
                    }}>
                    {l.label !== "View Application"  && (
                      <img src={Chatbot} alt="Chatbot" />
                    )}
                    {l.label}
                  </a>
                ))}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  </Card>
);

export default ActivityFeedCard;
